import { Component } from '@angular/core';
import { BaseInputComponent } from './../base-input/base-input.component';

@Component({
	selector: 'app-nop-input',
	template: ` <div class="col-12 p-0"></div> `,
	standalone: true
})
export class NopInputComponent extends BaseInputComponent {}
